export enum EnumClassNameAuthEnum {
    NOTIFICATION_TYPE = "App\\Model\\PhpEnum\\NotificationTypeEnum",
}
